import ParameterErrors from '../errors/ParameterErrors';
const {throwNotProvided}=ParameterErrors;
export default class PlotStatusConfiguration{
	static get UNIT_MARKER_COLOR_SUFFIX(){
		return '-unit-marker-color';
	}
	constructor(props){
		const {unitMarkerColor, configuratorIconFileName, plotStatus} = props;
		if(plotStatus===undefined||plotStatus===null)
			throwNotProvided('plotStatus');
		if(unitMarkerColor===undefined||unitMarkerColor===null)
			throwNotProvided('unitMarkerColor');
		this._plotStatus = plotStatus;
		this._unitMarkerColor=unitMarkerColor;
		this._configuratorIconFileName=configuratorIconFileName;
	}
	get unitMarkerColor(){
		return this._unitMarkerColor;
	}
	get configuratorIconFileName(){
		return this._configuratorIconFileName;
	}
	get plotStatus(){
		return this._plotStatus;
	}
	static fromEnumAndJObject (plotStatus, jObject){
		const unitMarkerColor = jObject.unitMarkerColor
		return new PlotStatusConfiguration({plotStatus:plotStatus, 
			unitMarkerColor:unitMarkerColor, configuratorIconFileName:jObject.configuratorIconFileName});
	}
}